import { initReactI18next } from "react-i18next";
import KO from "constant/locales/ko/translator.json";
import EN from "constant/locales/en/translator.json";
import JA from "constant/locales/ja/translator.json";
import TH from "constant/locales/th/translator.json";
import VI from "constant/locales/vi/translator.json";
import ZH from "constant/locales/zh/translator.json";
import i18n from "i18next";

// info.Language.language → 없으면 env → 없으면 'ja'
let defaultLanguage = process.env.REACT_APP_LOCALE || 'ja'
try {
  const parsed = JSON.parse(localStorage.getItem('info'))
  if (parsed?.Language?.language) defaultLanguage = parsed.Language.language
} catch (e) {}

// 다국어 지원을 초기화하고 번역 리소스를 설정합니다.
i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: KO },
    en: { translation: EN },
    ja: { translation: JA },
    th: { translation: TH },
    vi: { translation: VI },
    zh: { translation: ZH },
  },
  lng: defaultLanguage, // 개발: ko, 배포: ja
  fallbackLng: "ko", // 기본 폴백 언어는 한국어
  interpolation: {
    escapeValue: false, // React는 이미 XSS를 방지합니다.
  },
  react: {
    bindI18n: "languageChanged",
    bindStore: false,
    nsMode: "default",
  },
});

export default i18n;
